import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { EntityType } from 'api'
import { Selectbox } from 'view/components/options'
import { Field } from 'view/components/inputs'
import { CollectionHelper } from 'model'
import { createSortedEntityIdsSelector, createEntityGetterSelector } from 'selectors/entitySelectors'
import { Locale, Translation } from 'locale'

/* Collection */

export const CollectionSelectboxBase = connect(
  createStructuredSelector({
    getOption: createEntityGetterSelector(EntityType.COLLECTION)
  }),
  null,
  null,
  { forwardRef: true }
)(Selectbox)

CollectionSelectboxBase.defaultProps = {
  getOptionText: CollectionHelper.getName,
  noItemsText: Locale.translate(Translation.SC_N_COLLECTIONS, { count: 0 })
}

export const CollectionSelectboxBaseField = Field(CollectionSelectboxBase)

export const CollectionSelectbox = connect(
  createStructuredSelector({
    optionKeys: createSortedEntityIdsSelector(EntityType.COLLECTION)
  }),
  null,
  null,
  { forwardRef: true }
)(Selectbox)

export const CollectionSelectboxField = Field(CollectionSelectbox)
